import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const payloadCms = defineConnector({
  identifier: "payloadCms",
  name: "Payload CMS",
  tagLine: "Headless content management system",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.payloadcms.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "users API-Key",
      },
    ]),
  steps: [
    {
      title: "Enter your Payload CMS instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-app.payloadcms.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Enable API keys for the Users collection in your Payload config, then generate an API key from the admin panel. See the [API docs](https://payloadcms.com/docs/authentication/api-keys) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/users/me`,
  },
});
